import * as THREE from "three";
import Experience from "../Experience.js";

export default class Floor {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;

    this.setGeometry();
    this.setTextures();
    this.setMaterial();
    this.setMesh();
  }

  setGeometry() {
    this.geometry = new THREE.PlaneGeometry(6, 6);
  }

  setTextures() {
    this.textures = {};
    this.textures.color = this.resources.items.floorColorTexture;
    this.textures.color.encoding = THREE.sRGBEncoding;
    this.textures.normal = this.resources.items.floorNormalTexture;
    this.textures.ao = this.resources.items.floorAmbientOcclusionTexture;
    this.textures.metalness = this.resources.items.floorMetalnessTexture;
    this.textures.roughness = this.resources.items.floorRoughnessTexture;
    this.textures.displacement = this.resources.items.floorHeightTexture;
    this.textures.scale = [2, 2];

    this.textures.color.repeat.set(
      this.textures.scale[0],
      this.textures.scale[1]
    );
    this.textures.normal.repeat.set(
      this.textures.scale[0],
      this.textures.scale[1]
    );
    this.textures.ao.repeat.set(this.textures.scale[0], this.textures.scale[1]);
    this.textures.metalness.repeat.set(
      this.textures.scale[0],
      this.textures.scale[1]
    );
    this.textures.roughness.repeat.set(
      this.textures.scale[0],
      this.textures.scale[1]
    );
    this.textures.displacement.repeat.set(
      this.textures.scale[0],
      this.textures.scale[1]
    );

    this.textures.color.wrapS = THREE.RepeatWrapping;
    this.textures.normal.wrapS = THREE.RepeatWrapping;
    this.textures.ao.wrapS = THREE.RepeatWrapping;
    this.textures.metalness.wrapS = THREE.RepeatWrapping;
    this.textures.roughness.wrapS = THREE.RepeatWrapping;
    this.textures.displacement.wrapS = THREE.RepeatWrapping;

    this.textures.color.wrapT = THREE.RepeatWrapping;
    this.textures.normal.wrapT = THREE.RepeatWrapping;
    this.textures.ao.wrapT = THREE.RepeatWrapping;
    this.textures.metalness.wrapT = THREE.RepeatWrapping;
    this.textures.roughness.wrapT = THREE.RepeatWrapping;
    this.textures.displacement.wrapT = THREE.RepeatWrapping;
  }

  setMaterial() {
    this.material = new THREE.MeshStandardMaterial({
      map: this.textures.color,
      aoMap: this.textures.ao,
      normalMap: this.textures.normal,
      metalnessMap: this.textures.metalness,
      roughnessMap: this.textures.roughness,
      displacementMap: this.textures.displacement,
      displacementScale: 0.01,
    });
  }

  setMesh() {
    this.mesh = new THREE.Mesh(this.geometry, this.material);
    this.mesh.position.set(0, -1.15, 3);
    this.mesh.rotation.set(Math.PI * 1.5, 0, 0);
    this.mesh.name = "floor";

    this.mesh.receiveShadow = true;
    this.geometry.setAttribute(
      "uv2",
      new THREE.Float32BufferAttribute(this.geometry.attributes.uv.array, 2)
    );
    this.scene.add(this.mesh);
  }
}
